import React from 'react';
import ReportingMarketingEmailPage from '../components/ReportingMarketingEmailPage';

const ReportingMarketingEmailApp = (props) => (
  <ReportingMarketingEmailPage {...props} />
);

export default ReportingMarketingEmailApp;
